import { jsx as _jsx } from "react/jsx-runtime";
import { SuperSmallNewsCard } from "@nitra/nkmb-card-components/cards";
export function MobileSmallWithTextNewsCard(props) {
    var isFootballSchoolNewsArticle = props.isFootballSchoolNewsArticle;
    var _a = props.data, title = _a.title, createdAt = _a.createdAt, firestoreId = _a.firestoreId, image104x141url = _a.image104x141url;
    return (_jsx(SuperSmallNewsCard, { title: title, createdAt: createdAt, to: isFootballSchoolNewsArticle ? "/footballSchool/news/".concat(firestoreId) : "/news/".concat(firestoreId), imageUrl: image104x141url }));
}
